<template>
  <div class="radio-btn radio-btn-single">
    <label class="radio-btn__label">
      <input
        type="radio"
        :value="item.value"
        :name="item.name"
        :checked="item.value === value"
        @change="onChange"
      />
      <span class="radio-btn__span"></span>
      <span class="radio-btn__name">
        {{ item.label }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    value: null
  },
  methods: {
    onChange() {
      this.$emit('update:value', this.item.value);
    }
  }
}
</script>

<style lang="scss">
.radio-btn {
  display: flex;
  flex-wrap: wrap;

  &__label {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  input {
    margin-top: -3px;
  }

  &__name {
    color: #6c7073;
    font-family: $OpenSans;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    margin-left: 10px;

    @include media-max($tablet-width) {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseRadioSingle.vue